import { useScheduleEditorIds } from "./use-schedule-editor-ids"
import { getScheduleEditorSessionRef } from "../lib/schedule-editor-session"

/** True when rendered inside an active ScheduleEditor session. */
export function useIsAuthoringScheduleEditor() {
    const { draftId } = useScheduleEditorIds()
    return Boolean(getScheduleEditorSessionRef(draftId))
}
